import { useState } from "react";

import {
  EyeInvisibleOutlined,
  // UserOutlined,
  EyeTwoTone,
  // PhoneOutlined,
  LockOutlined,
} from "@ant-design/icons";
import { Button, Form, Image, Input, message, Typography } from "antd";
import { IoLogInOutline } from "react-icons/io5";

import axios from "axios";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import loginImage from "../../../assets/img/login-image.png";
import resolvedLogo from "../../../assets/img/pickpacknewlogo.svg";
import techPackIcon from "../../../assets/img/TechPack.svg";
import { PASSWORD_HINT, passwordRules } from "../../../utils/formRules";

const { Text, Title } = Typography;
const currentYear = new Date().getFullYear();

const ChangePassword = () => {
  const location = useLocation();
  const history = useHistory();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const { data } = await axios.post("/auth/forgetPassword", {
        email: location?.state?.email,
        resetToken: location?.state?.resetToken,
        ...values,
      });
      setLoading(false);

      if (data?.statusCode === 200) {
        message.success(data?.result?.message || "Амжилттай", 5);
        history.push("/");
      }
    } catch (error) {
      setLoading(false);
    }
  };

  if (!location?.state?.email || !location?.state?.resetToken)
    return <Redirect to="/forgot-password" />;

  return (
    <div className="fp-wrapper">
      {/* Left — cover image */}
      <div className="fp-cover">
        <div
          className="fp-cover-bg"
          style={{ backgroundImage: `url(${loginImage})` }}
        />
        <div className="fp-cover-overlay" />
      </div>

      {/* Right — form card */}
      <div className="fp-form-side">
        <div className="fp-form-main">
          <div className="fp-form-card">
            {/* Logo */}
            <div className="fp-logo-wrap">
              <Image
                src={resolvedLogo}
                className="fp-logo"
                alt="logo"
                preview={false}
              />
            </div>

            {/* Heading */}
            <div className="fp-heading">
              <Title level={3} className="fp-title">
                Нууц үг солих
              </Title>
              <Text className="fp-subtitle">Шинэ нууц үгээ оруулна уу.</Text>
            </div>

            {/* Form */}
            <Form
              form={form}
              name="normal_login"
              layout="vertical"
              className="fp-form"
              labelAlign="left"
              initialValues={{ remember: true }}
              onFinish={onFinish}
            >
              <Form.Item
                name="password"
                label="Нууц үг"
                rules={passwordRules()}
                extra={PASSWORD_HINT}
                hasFeedback
              >
                <Input.Password
                  size="large"
                  prefix={<LockOutlined />}
                  placeholder="Нууц үг"
                  autoComplete="current-password"
                  iconRender={(visible) =>
                    visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                  }
                />
              </Form.Item>

              <Form.Item
                name="repeatPassword"
                label="Нууц үг давтах"
                dependencies={["password"]}
                rules={[
                  { required: true, message: "Нууц үгээ давтана уу!" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Нууц үг таарахгүй байна!"),
                      );
                    },
                  }),
                ]}
              >
                <Input.Password
                  size="large"
                  prefix={<LockOutlined />}
                  placeholder="Нууц үг давтах"
                  autoComplete="new-password"
                />
              </Form.Item>

              <Form.Item style={{ marginBottom: 0, marginTop: 8 }}>
                <Button
                  type="primary"
                  size="large"
                  className="fp-submit-btn"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  icon={<IoLogInOutline size={16} />}
                  htmlType="submit"
                  loading={loading}
                  block
                >
                  Хадгалах
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
        {/* Footer */}
        <div className="fp-footer">
          <div className="fp-footer-brand">
            <span className="fp-powered">Powered by</span>
            <Image
              src={techPackIcon}
              preview={false}
              className="fp-techpack-logo"
              alt="TechPack"
            />
          </div>
          <span className="fp-copyright">
            © 2021-{currentYear} Зохиогчийн эрх хамгаалагдсан
          </span>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
